import React, { Component } from 'react';
//import Map from './Map';
//import System from './System';
//import Position from './Position';
//import Register from './Register';
//import Checkout from './Checkout'
import ReactGA from 'react-ga';
import NumericInput from 'react-numeric-input';
import { Input,Dropdown, Popup} from 'semantic-ui-react';

import '../style/Content.css'


import CSImage from '../image/cs-roof.jpg'
import tileImage from '../image/tile-roof.png'
import metalImage from '../image/metal-roof.png'
import DIYImage from '../image/diy-roof.png'

//const steps =
//  [
//    {name: 'Location', component: <Map />},
//    {name: 'System Size', component: <System />},
//    {name: 'Position', component: <Position />},
//    {name: 'Register', component: <Register />},
//    {name: 'Checkout', component: <Checkout />},
//
//  ]

const ACPower = [
  {
    key: '120VAC (USA/CAN)',
    text: '120VAC (USA/CAN)',
    value: '120VAC (USA/CAN)',
  },
  {
    key: '230VAC (EU/AU/ASIA)',
    text: '230VAC (EU/AU/ASIA)',
    value: '230VAC (EU/AU/ASIA)',
  },
];


const mountOptions = [
  {
    key: 'Composite Shingle',
    text: 'Composite Shingle',
    value: 'Composite Shingle',
    image: { avatar: true, src: CSImage },
  },
  {
    key: 'Tile',
    text: 'Tile',
    value: 'Tile',
    image: { avatar: true, src: tileImage },
  },
  {
    key: 'Metal',
    text: 'Metal',
    value: 'Metal',
    image: { avatar: true, src: metalImage },
  },
  {
    key: 'DIY',
    text: 'DIY',
    value: 'DIY',
    image: { avatar: true, src: DIYImage },
  },

];

const defaultBatteryCommander = [
  {
    key: 0,
    text: 0,
    value: 0
  }
];

const defaultLithiumBattery = [
  {
    key: 0,
    text: 0,
    value: 0
  }
];

const offGridController = [
  {
    key: 0,
    text: 0,
    value: 0
  },
  {
    key: 1,
    text: 1,
    value: 1
  }
];

const offGridInverter = [
  {
    key: 0,
    text: 0,
    value: 0
  },
  {
    key: 1,
    text: 1,
    value: 1
  }
];


class Content extends Component{

    constructor(props) {
      super(props);
      this.state = {
        watts: 0,
        price: 0,
        priceAfterIncentives: 0,
        sunlightHours: 12,
        pricePerKw: 0.35,
        ACPower: '120VAC (USA/CAN)',
        mountType: null,
        itemList:[],
        batteryCommander: 0,
        batteryCommanderOptions: defaultBatteryCommander,
        lithiumBattery: 0,
        lithiumBatteryOptions: defaultLithiumBattery,
        offGridController: 0,
        offGridInverter: 0,
        disabled : true,
      }
      this.link = 'http://www.plxdevices.com/ShoppingCart.asp?';
    }

    componentDidMount () {
      localStorage.clear();
      localStorage.setItem('step', 0);
      ReactGA.initialize('UA-120152287-1'); //Unique Google Analytics tracking number
      ReactGA.pageview('shop');
    }

  handleWattChange(number){
    const wattsNumber = parseInt(number,10);

    if(wattsNumber === 0){
     this.setState({ disabled: true,batteryCommander:defaultBatteryCommander})
     this.setState( {disabled: true,lithiumBattery:defaultLithiumBattery})
    }else{
      const batteryCommanderLength = (wattsNumber / 300) + 1;
      let batteryCommanderOptions = [];
      for (var i = 0; i < batteryCommanderLength; i++) {
        batteryCommanderOptions.push({
          key: i, value: i , text: i,
        })
      }
      this.setState({ disabled: false, batteryCommanderOptions})
    }
    const price = this.calculatePrice(wattsNumber);

    this.setState({
      watts : wattsNumber
    })

    this.setPrices(price);

  }

  onSunlightHoursChange = hours => {
    this.setState({
      sunlightHours: hours
    });
  }

  onPricePerKwChange = price => {
    if( isNaN(price) ) return;
    this.setState({
      pricePerKw: price
    }, () =>
      {
        const price = this.calculatePrice(this.state.watts);
        this.setPrices(price);

      });
  }
  ACPowerChange(event,data){
    this.setState({
      ACPower : data.value
    }, () =>
      {
        const price = this.calculatePrice(this.state.watts);
        this.setPrices(price);

      });

  }

  OffGridControllerChange(event,data){
    this.setState({
      offGridController : data.value
    }, () =>
      {
        const price = this.calculatePrice(this.state.watts);
          this.setPrices(price);
      });

  }


  OffGridInverterChange(event,data){
    this.setState({
      offGridInverter : data.value
    }, () =>
      {
        const price = this.calculatePrice(this.state.watts);
          this.setPrices(price);
      });

  }

  BatteryCommanderChange(event,data){

    const batteryCommanderNumber = parseInt(data.value, 10);

    if(batteryCommanderNumber === 0){
      this.setState( {disabled: true,lithiumBattery:defaultLithiumBattery})
    }else{
      const lithiumBatteryLength = batteryCommanderNumber + 1;
      let lithiumBatteryOptions = [];
      for (var j=0; j<lithiumBatteryLength; j++){
        lithiumBatteryOptions.push({
          key: j, value: j, text: j,
        })
      }
      this.setState({ disabled: false, lithiumBatteryOptions})
      
      
    }
    this.setState({
      batteryCommander: data.value
    }, () =>
    {
      const price = this.calculatePrice(this.state.watts);
      this.setPrices(price);
    })
  };

  LithiumBatteryChange(event,data){
    this.setState({
      lithiumBattery: data.value
    }, () =>
    {
      const price = this.calculatePrice(this.state.watts);
    this.setPrices(price);

  })
  };


  federalTaxValue = year => {
    if (year >= 2017 && year <= 2019) {
      return 0.7;
    }
    if (year === 2020) return 0.74;
    if (year === 2021) return 0.74;
    if (year === 2022) return 0.74;
    if (year === 2023) return 0.78
    if(year >= 2024) return 1;
  };

  MountChange(event,data){
    this.setState({
      mountType: data.value
    }, () =>
    {
      const price = this.calculatePrice(this.state.watts);
    this.setPrices(price);

  })

  };

  addItem = (items, name , quantity ,each , key, productCode) => {
    if(quantity > 0){
      items.push(
        {
          key: key,
          quantity: quantity,
          name: name,
          each: each,
        }
      );
      this.link = this.link + 'ProductCode='+ productCode +'&Qty.'+ productCode+ '=' + quantity+'&';
      return items;
    }
  }

  calculatePrice =( watts) =>{

    var items = [];
    this.link = 'http://www.plxdevices.com/ShoppingCart.asp?';
    var sStarterSet = 0;
    var lStarterSet = 0;
    var sExpentionSet = 0;
    var lExpentionSet = 0;

    var RailSet = 0;
    var MidKit = 0;
    var EndClampKit = 0;
    var SpliceKit = 0;
    var GroundLug = 0;
    var RailEndCaps = 0;

    var TileNumber = 0 ;
    var ComNumber = 0;
    var MetalNumber = 0 ;

    var TileMF = 0;
    var ComMF = 0;
    var MetalMF = 0;

    var panelSetNumber = (parseInt(watts, 10)) /300;
    var store = [
      [0, 0,  0,  0,  0,  0,  0,  0],
      [1, 0,  4,  1,  2,  2,  0,  1],
      [1,	1,	4,	1,	4,	2,	0,	1],
      [1,	2,	8,	2,	7,	5,	1,	2],
      [1,	3,	8,	2,	9,	5,	1,	2],
      [1,	4,	12,	3,	11,	8,	2,	3],
      [1,	5,	12,	3,	13,	8,	2,	3],
      [1,	6,	16,	4,	16,	10,	3,	4],
      [1,	7,	16,	4,	18,	10,	3,	4],
      [1,	8,	18,	5,	20,	11,	4,	4],
      [1,	9,	18,	5,	22,	11,	4,	4],
      [1,	10,	20,	6,	25,	11,	5,	4],
      [1,	11,	20,	6,	27,	11,	5,	4],
      [1,	12,	22,	7,	29,	12,	6,	4],
      [1,	13,	22,	7,	31,	12,	6,	4],
      [1,	14,	24,	8,	33,	12,	7,	4],
      [1,	15,	24,	8,	35,	12,	7,	4],
      [1,	16,	28,	9,	37,	12,	8,	4],
      [1,	17,	28,	9,	39,	12,	8,	4],
      [1,	18,	30,	10,	41,	12,	9,	4],
      [1,	19,	30,	10,	43,	12,	9,	4],
      [1,	20,	32,	11,	45,	12,	10,	4],
      [1,	21,	32,	11,	47,	12,	10,	4],
      [1,	22,	34,	12,	49,	12,	11,	4],
      [1,	23,	34,	12,	51,	12,	11,	4],
      [1,	24,	38,	13,	53,	12,	12,	4],
      [1,	25,	38,	13,	55,	12,	12,	4],
      [1,	26,	40,	14,	57,	12,	13,	4],
      [1,	27,	40,	14,	59,	12,	13,	4],
      [1,	28,	42,	15,	61,	12,	14,	4],
      [1,	29,	42,	15,	63,	12,	14,	4],
      [1,	30,	44,	16,	65,	12,	15,	4],
      [1,	31,	44,	16,	67,	12,	15,	4]

    ];
    var eachItems = store[panelSetNumber];

    if(this.state.ACPower==='120VAC (USA/CAN)'){
      sStarterSet = eachItems[0];
      sExpentionSet = eachItems[1];
    }else if(this.state.ACPower==='230VAC (EU/AU/ASIA)'){
      lStarterSet = eachItems[0];
      lExpentionSet = eachItems[1];
    }


    for( let i = 0; i < panelSetNumber; i++){
      if(this.state.mountType==='Tile'){
        TileNumber++;
      }else if(this.state.mountType==='Metal'){
        MetalNumber ++;
      }else if(this.state.mountType==='Composite Shingle'){
        ComNumber ++;
      }
    }

    var TileMountItmes = store[TileNumber];

    TileMF = TileMountItmes[2];
    RailSet += TileMountItmes[3];
    MidKit += TileMountItmes[4];
    EndClampKit += TileMountItmes[5];
    RailEndCaps += TileMountItmes[5];
    SpliceKit += TileMountItmes[6];
    GroundLug += TileMountItmes[7];
    var MetalMountItems = store[MetalNumber];

    MetalMF = MetalMountItems[2];
    RailSet += MetalMountItems[3];
    MidKit += MetalMountItems[4];
    EndClampKit += MetalMountItems[5];
    RailEndCaps += MetalMountItems[5];
    SpliceKit += MetalMountItems[6];
    GroundLug += MetalMountItems[7];
    var ComMountItems = store[ComNumber];

    ComMF = ComMountItems[2];
    RailSet += ComMountItems[3];
    MidKit += ComMountItems[4];
    EndClampKit += ComMountItems[5];
    RailEndCaps += ComMountItems[5];
    SpliceKit += ComMountItems[6];
    GroundLug += ComMountItems[7];


    this.addItem(items,'Legion Solar Starter Set 120VAC',sStarterSet,'659.00','LEGION SOLAR STARTER SET 120VAC','897346002696');
    this.addItem(items,'Legion Solar Starter Set 230VAC',lStarterSet,'659.00','LEGION SOLAR STARTER SET 230VAC','897346002702');
    this.addItem(items,'Legion Solar Expension Set 120VAC',sExpentionSet,'499.00','LEGION SOLAR EXPANSION SET 120VAC','897346002610');
    this.addItem(items,'Legion Solar Expension Set 230VAC',lExpentionSet,'499.00','LEGION SOLAR EXPANSION SET 230VAC','897346002603');

    this.addItem(items,'Legion Solar Tile Top Mount w/ L-Foot',TileMF,'65.00','LEGION SOLAR TILE TOP MOUNT W/ L-FOOT','897346002054');
    this.addItem(items,'Legion Solar Metal Roof Mount w/ L-Foot',MetalMF,'20.00','LEGION SOLAR COMPOSITE SHINGLE EZ ROOF MOUNT W/ L-FOOT','897346002061');
    this.addItem(items,'Legion Solar Composite Shingle Nano Roof Mount /w L-Foot',ComMF,'22.00','LEGION SOLAR COMPOSITE SHINGLE NANO ROOF MOUNT W/ L-FOOT','897346002122');

    this.addItem(items,'Legion Solar SMR100 Aluminum 110" Rail (Set of 2qty)',RailSet,'60.00','LEGION SOLAR SMR100 ALUMINUM 110"','897346002689');
    this.addItem(items,'Legion Solar Mid Clamp Kit (Set of 2qty)',MidKit,'14.00','LEGION SOLAR MID CLAMP KIT','897346002160');
    this.addItem(items,'Legion Solar End Clamp Kit (Set of 2qty)',EndClampKit,'10.00','LEGION SOLAR END CLAMP KIT','897346002153');

    this.addItem(items,'Legion Solar Rail End Caps (Set of 2qty)',RailEndCaps,'2.50','LEGION SOLAR RAIL END CAPS','897346002078');
    this.addItem(items,'Legion Solar Rail Splice Kit (Set of 2qty)',SpliceKit,'30.00','LEGION SOLAR RAIL SPLICE KIT','897346002146');
    this.addItem(items,'Legion Solar Grounding Lug',GroundLug,'12.00','LEGION SOLAR GROUNDING LUG','897346002139');

    this.addItem(items,'Legion Solar Off Grid Controller',this.state.offGridController,'199.00','LEGION SOLAR OFF GRID CONTROLLER','897346002580');
    this.addItem(items,'Legion Solar Off Grid Inverter',this.state.offGridInverter,'399.00','LEGION SOLAR OFF GRID INVERTER','897346002665');
    this.addItem(items,'Legion Solar Battery Commander',this.state.batteryCommander,'129.00','LEGION SOLAR BATTERY COMMANDER','897346002597');
    this.addItem(items,'Legion Solar Lithium Battery',this.state.lithiumBattery,'1199.00','LIGION SOLAR LITHIUM BATTERY','897346002245');

    this.link = this.link.substring(0, this.link.length - 1);

    let price = 0;
    let total = 0;



    items.forEach(
      (items) => {
        price = (items.each * items.quantity).toFixed(2);
        total += parseFloat(price,0)
      });

    return total;
  }


  setPrices = (price) => {

    const priceAfterIncentives = Math.ceil(price * this.federalTaxValue(new Date().getFullYear()));
    this.setState({
      price,
      priceAfterIncentives
    })
  }

    render(){

      const monthlyEnergy = this.state.sunlightHours * 0.5 * (this.state.watts / 1000) * 0.8 * parseFloat(this.state.pricePerKw) * 30;
      const yearlyEnergy = monthlyEnergy * 12;
      const lifetimeEnergy = yearlyEnergy * 42.87;

      return (
        <div className="row">
          <div className="col-xl-12 col-md-12 col-sm-12">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 offset-md-0 col-sm-10 offset-sm-1 left-sec" >
                <h3 className="text-center" style={{"padding" : "10px 0 0 0" }}>Build Your System</h3>
                <div className="row inner">
                  <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-7 col-sm-12">
                    <span className="label">Select your system size</span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-5 col-sm-12">
                    <NumericInput
                      className='number_control'
                      strict={true}
                      value={this.state.watts}
                      min={0}
                      max={9600}
                      step={300}
                      mobile={false}
                      format={number => number + ' watts'}
                      onChange={valueAsNumber => this.handleWattChange(valueAsNumber)}
                    />
                  </div>
                </div>
                <div className="row inner sellect">
                  <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-7 col-sm-12">
                    <span className="label label-ac-power">Select your AC Power</span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-5 col-sm-12">
                    <Dropdown
                      className='acPower'
                      placeholder='Chose your AC power'
                      selection options={ACPower}
                      value={this.state.ACPower}
                      onChange ={(e,data) => this.ACPowerChange(e,data)}
                    />
                  </div>
                </div>


                <div className="row inner">
                  <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-6 col-sm-12">
                    <span className="label label-mount-type">Mount Type</span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                    <Dropdown
                      className="mount-type"
                      placeholder='Select Type'
                      selection options={mountOptions}
                      value={this.state.mountType}
                      onChange ={(e,data) => this.MountChange(e,data)}
                    />
                  </div>
                </div>


                  <div className="row inner">
                    <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-6 col-sm-12">
                      <span className="label label-commander-type">Battery Commander</span>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                      <Dropdown
                        className="battery-type"
                        selection options={this.state.batteryCommanderOptions}
                        value={this.state.batteryCommander}
                        onChange ={(e,data) => this.BatteryCommanderChange(e,data)}
                      />
                    <span className="price-tooltip pos-abs pos-abs2">
                       <Popup
                         basic
                         hoverable={true}
                         trigger={<div className="icon-parent"><i className="info icon"></i></div>}

                         on='hover'
                         style={{
                               backgroundColor: "#c0c2d1",
                               color: "#333",
                               float: "right",
                               fontSize: "14px"
                             }}
                       ><a href="https://www.plxdevices.com/legionsolarbatterycommanderbrochure" target="_blank" rel="noopener noreferrer">Battery Commander Brochure</a>.</Popup>
                      </span>
                    </div>
                  </div>




                  <div className="row inner">
                    <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-6 col-sm-12">
                      <span className="label label-commander-type">Lithium Battery</span>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                      <Dropdown
                        className={this.state.disabled ? 'battery-type disabled' : 'battery-type'}
                        selection options={this.state.lithiumBatteryOptions}
                        value={this.state.lithiumBattery}
                        onChange ={(e,data) => this.LithiumBatteryChange(e,data)}
                      />
                    <span className="price-tooltip pos-abs pos-abs2">
                       <Popup
                         basic
                         hoverable={true}
                         trigger={<div className="icon-parent"><i className="info icon"></i></div>}

                         on='hover'
                         style={{
                               backgroundColor: "#c0c2d1",
                               color: "#333",
                               float: "right",
                               fontSize: "14px"
                             }}
                       ><a href="https://www.plxdevices.com/legionsolarlithiumbatterybrochure" target="_blank" rel="noopener noreferrer">Lithium Battery Brochure</a>.</Popup>
                      </span>
                    </div>
                  </div>

                  <div className="row inner">
                    <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-6 col-sm-12">
                      <span className="label label-commander-type">Off Grid Controller</span>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                      <Dropdown
                        className={this.state.disabled ? 'battery-type disabled' : 'battery-type'}
                        selection options={offGridController}
                        value={this.state.offGridController}
                        onChange ={(e,data) => this.OffGridControllerChange(e,data)}
                      />
                    <span className="price-tooltip pos-abs pos-abs2">
                       <Popup
                         basic
                         hoverable={true}
                         trigger={<div className="icon-parent"><i className="info icon"></i></div>}

                         on='hover'
                         style={{
                               backgroundColor: "#c0c2d1",
                               color: "#333",
                               float: "right",
                               fontSize: "14px"
                             }}
                       ><a href="https://www.plxdevices.com/legionsolaroffgridcontrollerbrochure" target="_blank" rel="noopener noreferrer">Off Grid Controller Brochure</a>.</Popup>
                      </span>
                    </div>
                  </div>


                  <div className="row inner">
                    <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-6 col-sm-12">
                      <span className="label label-commander-type">Off Grid Inverter</span>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                      <Dropdown
                        className={this.state.disabled ? 'battery-type disabled' : 'battery-type'}
                        selection options={offGridInverter}
                        value={this.state.offGridInverter}
                        onChange ={(e,data) => this.OffGridInverterChange(e,data)}
                      />
                    <span className="price-tooltip pos-abs pos-abs2">
                       <Popup
                         basic
                         hoverable={true}
                         trigger={<div className="icon-parent"><i className="info icon"></i></div>}

                         on='hover'
                         style={{
                               backgroundColor: "#c0c2d1",
                               color: "#333",
                               float: "right",
                               fontSize: "14px"
                             }}
                       ><a href="https://www.plxdevices.com/legionsolaroffgridinverterbrochure" target="_blank" rel="noopener noreferrer">Off Grid Inverter Brochure</a>.</Popup>
                      </span>
                    </div>
                  </div>


                <div className="row inner">
                  <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-7 col-sm-12">
                    <span className="label label-sunlight">
                      Average Sunlight Hours
                   </span>
                  </div>

                    <div className="col-xl-4 col-lg-4 col-md-5 col-sm-12">
                        <Input
                          className="avg-sunlight"
                          placeholder='Sunlight Hours'
                          value={this.state.sunlightHours}
                          onChange={e => this.onSunlightHoursChange(e.target.value)}
                        />

                      <span className="price-tooltip pos-abs">
                       <Popup
                         basic
                         hoverable={true}
                         trigger={<div className="icon-parent"><i className="info icon"></i></div>}

                         on='hover'
                         style={{
                               backgroundColor: "#c0c2d1",
                               color: "#333",
                               float: "right",
                               fontSize: "14px"
                             }}
                       >Enter the average number of daylight hours from dawn to dusk. Use March 22 or September
                         19 for average yearly daytime sunlight. <a href="https://www.timeanddate.com/sun/" target="_blank" rel="noopener noreferrer">Sunlight calculator tool.</a>.</Popup>
                      </span>
                    </div>
                </div>



                <div className="row inner">
                  <div className="col-xl-4 offset-xl-3 col-lg-5 offset-lg-1 col-md-7 col-sm-12">
                    <span className="label label-current-price">Your Current Price/kW</span>
                  </div>

                      <div className="col-xl-4 col-lg-4 col-md-5 col-sm-12">
                        <Input
                          className="price-per-kw"
                          placeholder='Current Price/kW'
                          value={this.state.pricePerKw}
                          onChange={e => this.onPricePerKwChange(e.target.value)}
                        />
                        <span className="price-tooltip pos-abs float-right">
                        <Popup
                          basic
                          trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                          content='Enter the cost per kW ($) from your energy company. Legion Solar can slow down your consumption to prevent you from entering into the higher priced tiers. Enter the cost of the higher price tiers to see your offset value.'
                          on='hover'
                          style={{
                                backgroundColor: "#c0c2d1",
                                color: "#333",
                                float: "right",
                                fontSize: "14px"
                              }}
                        />
                        </span>

                      </div>

                </div>

              </div>

              <div className="col-xl-6 col-lg-6 col-md-6 offset-md-0 col-sm-10 offset-sm-1 right-section-info" style={{background: "#e5ebf0"}}>
                <h3 className="second-h3 text-center">Price and Savings</h3>

                  <div className="row inner-right">
                    <div className="col-xl-6 offset-xl-4 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
                      <span className="price-tooltip">
                          <Popup
                            basic
                            trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                            content='Price excludes CA sales tax (if applicable) and shipping.'
                            on='hover'
                            style={{
                                  backgroundColor: "#c0c2d1",
                                  color: "#333",
                                  float: "right",
                                  fontSize: "14px"
                                }}
                          />
                          </span>
                          <span className="label label-total-price">Your System Price</span>
                          <span className="price pricekw">${this.state.price}</span>

                        </div>

                  </div>



                  <div className="row inner-right" style={{color: "darkorange"}}>
                    <div className="col-xl-6 offset-xl-4 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
                      <span className="price-tooltip">
                      <Popup
                        basic
                        hoverable={true}
                        trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                        on='hover'
                        style={{
                              backgroundColor: "#c0c2d1",
                              color: "#333",
                              float: "right",
                              fontSize: "14px"
                            }}
                      >Calculation for federal solar tax incentives applies to USA customers only. 2021,
                        2022 tax credit is 26%, 2023 tax credit is 22% and onward tax credit is 10% for 
                        commercial installations only. For details see <a target="_blank" rel="noopener noreferrer" href="https://www.irs.gov/forms-pubs/form-3468-investment-credit-2">IRS Form 3468</a>.</Popup>
                      </span>

                      <span className="label label-price-incentives">
                        Price After Incentives:
                      </span>
                      <span className="price">${this.state.priceAfterIncentives}</span>

                    </div>

                  </div>
                <div className="row inner-right">
                  <div className="col-xl-6 offset-xl-4 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
                    <span className="price-tooltip">
                    <Popup
                      basic
                      trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                      on='hover'
                      position="bottom right"
                      style={{
                            backgroundColor: "#c0c2d1",
                            color: "#333",
                            float: "right",
                            fontSize: "14px"
                          }}
                    >
                      Calculation assumes peak sunlight time is 1/2 total daylight time. Total production
                      output is approximated to 80% efficiency (inverter conversion, soiling, shading, wiring, mismatch). Solar panels are
                      assumed to be fixed mount angled for optimal spring/fall position in the direction of 180º azimuth for northern
                      hemisphere and 0º azimuth for southern hemisphere. Calculation does not consider local weather conditions.
                      Calculation assumes 30 day month and 100% consumption of energy produced. Use <a href="https://pvwatts.nrel.gov" target="_blank" rel="noopener noreferrer">PVWatts calculator</a> for
                      estimates for your local conditions.
                    </Popup>
                    </span>

                    <span className="label label-monthly-energy">Monthly Energy Value</span>
                      <span className="price price-energy">${monthlyEnergy.toFixed(2)}</span>

                  </div>
                </div>

                <div className="row inner-right">
                  <div className="col-xl-6 offset-xl-4 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
                    <span className="price-tooltip">
                    <Popup
                      basic
                      trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                      on='hover'
                      position="bottom right"
                      style={{
                            backgroundColor: "#c0c2d1",
                            color: "#333",
                            float: "right",
                            fontSize: "14px"
                          }}
                    >
                      Calculation of yearly energy value is monthly energy value * 12.
                    </Popup>
                    </span>

                    <span className="label label-yearly-energy">Yearly Energy Value</span>
                      <span className="price price-energy">${yearlyEnergy.toFixed(2)}</span>
                  </div>
                </div>

                <div className="row inner-right">
                  <div className="col-xl-8 offset-xl-4 col-lg-8 offset-lg-2 col-md-11 offset-md-1 col-sm-12">
                    <span className="price-tooltip">
                    <Popup
                      basic
                      trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                      on='hover'
                      position="bottom right"
                      style={{
                            backgroundColor: "#c0c2d1",
                            color: "#333",
                            float: "right",
                            fontSize: "14px"
                          }}
                    >
                      Calculation assumes average utility rate inflation of 3.15%/year and 0.8%/year PV panel
                      degradation for 30 years.
                    </Popup>
                    </span>

                    <span className="label label-lifetime-energy">Lifetime Energy Value</span>
                    <span className="price price-energy">${lifetimeEnergy.toFixed(2)}</span>
                  </div>
                </div>

                <div className="row inner-right">
                  <div className="col-xl-12 col-md-12 col-sm-12 text-center">
                    <span className="price-tooltip button-info">
                    <Popup
                      basic
                      trigger={<div className="icon-parent"><i className="info icon"></i></div>}
                      on='hover'
                      position="bottom right"
                      style={{
                            backgroundColor: "#c0c2d1",
                            color: "#333",
                            float: "right",
                            fontSize: "14px"
                          }}
                    >
                    If you already have a Starter Set, you can remove that item and any other item you already own after you’ve added to cart. You can
                    adjust quantities, and add accessories and other items as needed before checking out.
                    </Popup>
                    </span>
                    <a className="addCartBtn" href={this.link} rel="noopener noreferrer" target="_blank">
                        Add to Cart
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      )

    }
}
export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js